import { subclass } from '@arcgis/core/core/accessorSupport/decorators';
import { JepGraphicsLayer } from '@jeppesen-foreflight/jmkw-types';
import { TwcMixin } from '../../twc.mixin';

@subclass('jmkw.layers.TwcGraphicsLayer')
export class TwcGraphicsLayer extends TwcMixin(JepGraphicsLayer) {}
